'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var React = require('react');
var PermissionsContext = require('./PermissionsContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PermissionsProvider = ({ provider, existingCache = {}, children, }) => {
    const cache = Object.assign({}, existingCache);
    const onGoingRequests = {};
    const getPermissionsFromProvider = (application) => _tslib.__awaiter(void 0, void 0, void 0, function* () {
        const onGoingRequest = onGoingRequests[application];
        if (onGoingRequest) {
            return onGoingRequest;
        }
        const newRequest = provider.loadPermissions(application);
        onGoingRequests[application] = newRequest;
        return newRequest;
    });
    const isAllowed = (application, permission) => _tslib.__awaiter(void 0, void 0, void 0, function* () {
        if (application.length === 0 || permission.length === 0) {
            return false;
        }
        if (cache[application] === undefined) {
            try {
                cache[application] = yield getPermissionsFromProvider(application);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                cache[application] = [];
            }
        }
        return cache[application].includes(permission);
    });
    const providerValue = React.useMemo(() => ({ isAllowed }), []);
    return (React__default["default"].createElement(PermissionsContext["default"].Provider, { value: providerValue }, children));
};
PermissionsProvider.defaultProps = {
    existingCache: {},
};

exports["default"] = PermissionsProvider;
